import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Platform } from '@ionic/angular';
@Injectable({
  providedIn: 'root',
})
export class NavigationRedirectGuard implements CanActivate {
  private preventRedirect = false;
 constructor(private platform: Platform, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree  {
   if (this.platform.is('android') && this.preventRedirect) {
      return this.router.parseUrl('/tabs/bookings');
    }
    return true;
  }
   setPreventRedirect(value: boolean) {
    this.preventRedirect = value;
  }

  getPreventRedirect(): boolean {
    return this.preventRedirect;
  }
}

